import { Loader } from "@app/components/core/Loader/Loader"
import { SelectionGroup } from "@app/components/core/SelectionGroup/SelectionGroup"
import { LoungerTypeSelector } from "@app/components/order/LoungerTypeSelector/LoungerTypeSelector"
import { addLounger, removeLounger } from "@app/store/actions/orderActions"
import { useGetLoungerTypes } from "@app/store/service/cmsService"
import { useAvaiableObjects } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect, useState } from "react"

export default function LoungerSelection() {
	const [loaded, setLoaded] = useState(false)
	const [availableLoungers, setAvailableLoungers] = useState({})
	const [__notAvailableLoungers, setNotAvailableLoungers] = useState([])

	const zoneId = useSelector("core.zoneId")
	const loungers = useSelector("order.loungers")

	const loungerTypesRequest = useGetLoungerTypes({ zoneId }, { skip: !zoneId })
	const [loadAvailablity, availableRequest] = useAvaiableObjects()

	const sortAvailablity = useCallback(
		(loungerTypes, availableLoungers) => {
			const validLoungers = {}
			const invalidLoungers = []
			for (let group in loungerTypes) {
				for (let lounger of loungerTypes[group]) {
					let availability = availableLoungers.find(e => e.objectGroupId === lounger.objectGroupId)
					if (availability) {
						validLoungers[group] = validLoungers[group] || []
						validLoungers[group].push({
							...lounger,
							restCount: availability.restCount,
							price: availability.price,
							dynamicPriceLevelId: availability.dynamicPriceLevelId,
						})
					} else {
						invalidLoungers.push({ ...lounger })
					}
				}
			}

			setAvailableLoungers(validLoungers)
			setNotAvailableLoungers(invalidLoungers)

			setLoaded(true)
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[loungerTypesRequest.data, availableRequest.data],
	)

	useEffect(() => {
		appStore.set(state => ({
			order: {
				...state.order,
				availableLoungers: availableRequest.data,
			},
		}))
	}, [availableRequest.data])

	useEffect(() => {
		if (loungerTypesRequest.data && availableRequest.data) {
			sortAvailablity(loungerTypesRequest.data, availableRequest.data)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loungerTypesRequest.data, availableRequest.data])

	useEffect(() => {
		let intervall = null
		if (zoneId) {
			setLoaded(false)
			loadAvailablity({ date: new Date().toISOString().slice(0, 10) })
			intervall = setInterval(() => {
				setLoaded(false)
				loadAvailablity({ date: new Date().toISOString().slice(0, 10) })
			}, 1000 * 60)
		}

		return () => {
			clearInterval(intervall)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [zoneId])

	useEffect(() => {
		const update = () => {
			if (!availableRequest.isFetching) {
				loadAvailablity({ date: new Date().toISOString().slice(0, 10) })
			}
		}
		let timer = setInterval(update, 60000)
		const clickHandler = () => {
			clearInterval(timer)
			timer = setInterval(update, 60000)
		}

		window.addEventListener("click", clickHandler)
		return () => {
			clearInterval(timer)
			window.removeEventListener("click", clickHandler)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div className="onSiteSelection">
			<div className="f2 mb-3">Lounger auswählen</div>
			<div className="scrollable pr-4" style={{ maxHeight: "calc(100vh - 300px)" }}>
				{!zoneId ? (
					<div className="color-fg-danger f3">Bitte wähle erst einen Bereich.</div>
				) : (
					<>
						<Loader show={!loaded} />
						{loaded && Object.keys(availableLoungers).length === 0 && <div className="color-fg-danger f3">Keine Liegen verfügbar.</div>}
						{loaded &&
							Object.keys(availableLoungers)
								.sort()
								.map((key, index) => {
									return (
										<SelectionGroup
											key={index}
											title={
												<>
													<span className="uppercase">{key}</span>
													{key.toLowerCase() === "comfort" && (
														<>
															<span> - </span>
															<span className="color-fg-success">Unsere Empfehlung</span>
														</>
													)}
												</>
											}
										>
											{availableLoungers[key].map(lounger => {
												let restCountIsUsed = lounger.restCount - loungers.filter(e => e.lounger_id === lounger.lounger_id).length <= 0
												return (
													<LoungerTypeSelector
														key={lounger.objectGroupId}
														count={loungers.filter(e => e.lounger_id === lounger.lounger_id).length}
														imgSrc={lounger.image}
														name={lounger.loungerType + ` (${lounger.restCount})`}
														persons={lounger.capacity}
														price={lounger.price}
														onAdd={() => addLounger(lounger, true)}
														onRemove={() => removeLounger(lounger)}
														plusDisabled={restCountIsUsed}
													/>
												)
											})}
										</SelectionGroup>
									)
								})}
					</>
				)}
			</div>
		</div>
	)
}
